import "react";
import styles from "./Playbook.module.scss";
import { PlayModel } from "../../generated/from-api/models/play.model";
import { useContext, useEffect, useRef, useState } from "react";
import Tooltip from "../../components/Tooltip/Tooltip";
import { PlaySetsContext } from "../../shared/shared-with-mobile/providers/playSets.provider";
import { PlaybookContext } from "../../shared/shared-with-mobile/providers/playbook.provider";

interface Props {
  playsetId: string;
}

const PlaybookPlaySetTags: React.FC<Props> = ({ playsetId }) => {
  const rowRef: any = useRef(null);
  const [tags, setTags] = useState<string[]>([]);
  const [hiddenTags, setHiddenTags] = useState<string[]>([]);
  const { currentPlaybook } = useContext(PlaybookContext);
  const { playSets } = useContext(PlaySetsContext);

  useEffect(() => {
    const context = document?.createElement("canvas")?.getContext("2d");
    const font = "400 11pt sans-serif"; // Approximate font size to compare against
    if (context) context.font = font;
    const measureLength = (plays: string[]) => {
      if (!context) return 9999; // If for some reason that didn't initialize just return a large value
      const str = plays.join("  -  "); // Approximate the spacing between elements
      const text = context.measureText(str);
      return text.width;
    };

    const playTagsSet = new Set();

    const playSet = playSets.find((playset) => playset.id === playsetId);
    if (currentPlaybook && playSet) {
      const findPlayUsingPlayId: PlayModel[] = [];
      playSet.playOrder
        .map((playId) => playId.playId)
        .filter((e) => {
          const play = currentPlaybook.find((play) => play.id === e);
          if (play) {
            findPlayUsingPlayId.push(play);
          }
        });

      findPlayUsingPlayId.map((play) => {
        if (play.scheme) playTagsSet.add(play.scheme);
        if (play.situation) playTagsSet.add(play.situation);
        if (play.personnel) playTagsSet.add(play.personnel);
      });
    }

    const playTags = Array.from(playTagsSet) as string[];
    playTags.sort((a, b) => a.length - b.length);
    let rowLength = 200; // Default to 200px
    if (rowRef?.current) {
      rowLength = rowRef?.current?.offsetWidth;
    }
    // Calculate which tags to hide, note that this won't recalculate
    // on window resize, though we'll avoid a performance hit this way.
    for (let i = 1; i < playTags.length; i++) {
      if (measureLength(playTags.slice(0, i + 1)) > rowLength - 24) {
        setTags(playTags.slice(0, i));
        setHiddenTags(playTags.slice(i, playTags.length));
        return;
      }
    }
    setTags(playTags);
  }, [playSets, currentPlaybook]);
  const mapTags = () => {
    return (
      <>
        {tags.map((tag) => (
          <div key={tag} className={styles.tag}>
            {tag}
          </div>
        ))}
        {hiddenTags?.length > 0 && (
          <div key={"hiddenTags"} className={styles.tag}>
            <Tooltip tip={hiddenTags.join(", ")}>
              {"+" + hiddenTags.length}
            </Tooltip>
          </div>
        )}
      </>
    );
  };
  return (
    <div ref={rowRef} className={styles.tagsRow}>
      {mapTags()}
    </div>
  );
};

export default PlaybookPlaySetTags;
